module.exports = __webpack_public_path__ + "img/empty_bag.c5e8cc24.svg";